import {pluralize} from "@pg-mono/string-utils";

import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";
import {PREFERENCES_FORM_MAX_DEFAULT} from "../constants/preferences/application_preferences_form";
import {HomeMatchBasicPreferencesFlowSource} from "../types/HomeMatchBasicPreferencesFlowTypes";
import {IPreferencesDefaultValues} from "../types/IPreferencesDefaultValues";

export const getHomeMatchBasicSummaryCopy = (source: HomeMatchBasicPreferencesFlowSource) => {
    if (source === "afterLead") {
        return {
            title: "Zapytanie wysłane!",
            description: "Na podstawie wybranej oferty ustawiliśmy Twoje preferencje. Sprawdź, czy wszystko się zgadza, a my ułatwimy Ci dalsze poszukiwania.",
            buttonText: "Zapisz i wróć do ofert"
        };
    }

    return {
        title: "Szukasz podobnych mieszkań?",
        description: "Na podstawie wybranej oferty ustawiliśmy Twoje preferencje. Sprawdź, czy wszystko się zgadza, a my ułatwimy Ci dalsze poszukiwania.",
        buttonText: "ZATWIERDŹ"
    };
};

export const getHomeMatchBasicSurveyCopy = (isEditingSurvey: boolean) => {
    if (isEditingSurvey) {
        return {
            title: "Zmień swoje preferencje",
            description: "Dopasuj lokalizację, budżet i liczbę pokoi do tego, czego aktualnie szukasz.",
            closeButtonText: "PORZUĆ ZMIANY"
        };
    }

    return {
        title: "Potwierdź swoje preferencje",
        description: "Potwierdź swój budżet, lokalizację i liczbę pokoi, aby otrzymać lepiej spersonalizowane oferty.",
        closeButtonText: "ZAMKNIJ"
    };
};

export const getHomeMatchBasicRegionText = (values: IPreferencesDefaultValues, regionDetails?: IRegionListRegion[]) => {
    const regions = regionDetails?.length
        ? regionDetails.map((region) => region.short_name || region.name)
        : values.regionSelector.map((region) => region.label).filter(Boolean);

    return regions.length ? regions.join(", ") : "Nie wybrano lokalizacji";
};

export const getHomeMatchBasicRoomsText = (values: IPreferencesDefaultValues) => {
    const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

    const lower = values.rooms.lower;
    const upper = values.rooms.upper;

    if (!lower && !upper) {
        return "Dowolna liczba pokoi";
    }

    if (lower && upper && lower !== upper) {
        return `${lower}-${upper} ${roomsPluralize(parseInt(upper.toString(), 10))}`;
    }
    const roomsNumber = lower || upper;

    return `${roomsNumber} ${roomsPluralize(parseInt(roomsNumber.toString(), 10))}`;
};

export const getHomeMatchBasicBudgetText = (values: IPreferencesDefaultValues) => {
    if (!values.budget || values.budget >= PREFERENCES_FORM_MAX_DEFAULT) {
        return "bez limitu";
    }

    return `do ${values.budget.toLocaleString("pl-PL")} zł`;
};
import {pluralize} from "@pg-mono/string-utils";

import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";
import {PREFERENCES_FORM_MAX_DEFAULT} from "../constants/preferences/application_preferences_form";
import {HomeMatchBasicPreferencesFlowSource} from "../types/HomeMatchBasicPreferencesFlowTypes";
import {IPreferencesDefaultValues} from "../types/IPreferencesDefaultValues";

export const getHomeMatchBasicSummaryCopy = (source: HomeMatchBasicPreferencesFlowSource) => {
    if (source === "afterLead") {
        return {
            title: "Zapytanie wysłane!",
            description: "Na podstawie wybranej oferty ustawiliśmy Twoje preferencje. Sprawdź, czy wszystko się zgadza, a my ułatwimy Ci dalsze poszukiwania.",
            buttonText: "Zapisz i wróć do ofert"
        };
    }

    return {
        title: "Szukasz podobnych mieszkań?",
        description: "Na podstawie wybranej oferty ustawiliśmy Twoje preferencje. Sprawdź, czy wszystko się zgadza, a my ułatwimy Ci dalsze poszukiwania.",
        buttonText: "ZATWIERDŹ"
    };
};

export const getHomeMatchBasicSurveyCopy = (isEditingSurvey: boolean) => {
    if (isEditingSurvey) {
        return {
            title: "Zmień swoje preferencje",
            description: "Dopasuj lokalizację, budżet i liczbę pokoi do tego, czego aktualnie szukasz.",
            closeButtonText: "PORZUĆ ZMIANY"
        };
    }

    return {
        title: "Potwierdź swoje preferencje",
        description: "Potwierdź swój budżet, lokalizację i liczbę pokoi, aby otrzymać lepiej spersonalizowane oferty.",
        closeButtonText: "ZAMKNIJ"
    };
};

export const getHomeMatchBasicRegionText = (values: IPreferencesDefaultValues, regionDetails?: IRegionListRegion[]) => {
    const regions = regionDetails?.length
        ? regionDetails.map((region) => region.short_name || region.name)
        : values.regionSelector.map((region) => region.label).filter(Boolean);

    return regions.length ? regions.join(", ") : "Nie wybrano lokalizacji";
};

export const getHomeMatchBasicRoomsText = (values: IPreferencesDefaultValues) => {
    const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

    const lower = values.rooms.lower;
    const upper = values.rooms.upper;

    if (!lower && !upper) {
        return "Dowolna liczba pokoi";
    }

    if (lower && upper && lower !== upper) {
        return `${lower}-${upper} ${roomsPluralize(parseInt(upper.toString(), 10))}`;
    }
    const roomsNumber = lower || upper;

    return `${roomsNumber} ${roomsPluralize(parseInt(roomsNumber.toString(), 10))}`;
};

export const getHomeMatchBasicBudgetText = (values: IPreferencesDefaultValues) => {
    if (!values.budget || values.budget >= PREFERENCES_FORM_MAX_DEFAULT) {
        return "bez limitu";
    }

    return `do ${values.budget.toLocaleString("pl-PL")} zł`;
};
